import { useI18n } from "react-simple-i18n";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import { Layout } from "../components/layout/layout";
import { GlobalFirstSection } from "../components/layout/styles";

const StyledTable = styled('table')(({ theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: theme.spacing(4),
    '& th, & td': {
        border: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(2),
        textAlign: 'left',
    },
    '& th': {
        backgroundColor: theme.palette.grey[200],
        fontWeight: 'bold',
    },
    '& tbody tr:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));

const Extra = () => {
    const { t } = useI18n();

    return (
        <Layout>
            <StyledTable>
                <thead>
                    <tr>
                        <th>{t('businessInfo.title')}</th>
                        <th>{t('businessInfo.content')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>{t('businessInfo.seller.title')}</strong></td>
                        <td>{t('businessInfo.seller.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.representative.title')}</strong></td>
                        <td>{t('businessInfo.representative.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.location.title')}</strong></td>
                        <td>{t('businessInfo.location.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.phone.title')}</strong></td>
                        <td>{t('businessInfo.phone.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.businessHours.title')}</strong></td>
                        <td>{t('businessInfo.businessHours.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.email.title')}</strong></td>
                        <td><a target="_blank" href={`mailto:${t('businessInfo.email.content')}`}>{t('businessInfo.email.content')}</a></td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.website.title')}</strong></td>
                        <td><a target="_blank" href={t('businessInfo.website.content')}>{t('businessInfo.website.content')}</a></td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.productPrice.title')}</strong></td>
                        <td>{t('businessInfo.productPrice.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.additionalCosts.title')}</strong></td>
                        <td>{t('businessInfo.additionalCosts.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.paymentMethods.title')}</strong></td>
                        <td>{t('businessInfo.paymentMethods.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.paymentDeadline.creditCard.title')}</strong></td>
                        <td>{t('businessInfo.paymentDeadline.creditCard.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.paymentDeadline.bankTransfer.title')}</strong></td>
                        <td>{t('businessInfo.paymentDeadline.bankTransfer.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.paymentDeadline.otherMethods.title')}</strong></td>
                        <td>{t('businessInfo.paymentDeadline.otherMethods.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.deliveryTime.creditCard.title')}</strong></td>
                        <td>{t('businessInfo.deliveryTime.creditCard.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.deliveryTime.bankTransfer.title')}</strong></td>
                        <td>{t('businessInfo.deliveryTime.bankTransfer.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.returnsExchanges.title')}</strong></td>
                        <td>{t('businessInfo.returnsExchanges.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.returnShipping.title')}</strong></td>
                        <td>{t('businessInfo.returnShipping.content')}</td>
                    </tr>
                    <tr>
                        <td><strong>{t('businessInfo.businessContent.title')}</strong></td>
                        <td>{t('businessInfo.businessContent.content')}</td>
                    </tr>
                </tbody>
            </StyledTable>
        </Layout>
    )
}

export { Extra }